<template>
  <div>
    <!-- slot for parent component to activate the file changer -->
    <div @click="launchFilePicker()">
      <slot name="activator" />
    </div>

    <!-- image input: style is set to hidden and assigned a ref so that it can be triggered -->
    <input 
      ref="file"
      :name="fieldName"
      :accept="acceptType"
      :multiple="multiple"
      type="file"      
      style="display:none"      
      @change="onFileChange($event.target.name, $event.target.files)"      
    >

    <!-- error dialog displays any potential error messages -->
    <v-dialog 
      v-model="errorDialog" 
      max-width="300"
    >
      <v-card class="pt-4">
        <v-card-text> {{ errorText }} </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn 
            text
            @click="errorDialog = false"
          > 
            Got it!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      // Use "value" to enable using v-model
      value: {
        type: Object,
        default: null,
      },
      maxSizeInMb: {
        type: Number,
        required: true,
      },
      fieldName: {
        type: String,
        required: true,
      },
      acceptType: {
        type: String,
        required: true,
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      maxNumber: {
        type: Number,
        default: 1,
      },
    },
    data: () => ({
      errorDialog: null,
      errorText: '',
    }),  
    watch: {
      value: {
        handler (newValue) {
          if (!newValue) {
            this.$refs.file.value = ''
          }
        },
        deep: true,
      },
    },
    methods: {
      launchFilePicker () {
        this.$refs.file.click()
      },
      onFileChange (fieldName, files) {
        if (files.length <= 0) return

        if (files.length > this.maxNumber) {
          this.errorDialog = true
          this.errorText = `You can only upload maximum ${this.maxNumber} files`
          
          return
        }

        const formData = new FormData()
        const selectedFiles = []

        for (let i = 0, numFiles = files.length; i < numFiles; i++) {
          const file = files[i]
          const sizeInMb = this.bytesToMB(file.size)

          if (sizeInMb > this.maxSizeInMb) {
            // check whether the size is greater than the size limit
            this.errorDialog = true
            this.errorText = `Your file is too big! Please select a file under ${this.maxSizeInMb}MB`

            return
          } else {
            // Append file into FormData
            formData.append(`files[${i}]`, file)
            selectedFiles.push(file)
          }
        } 

        // Emit the FormData to the parent component
        this.$emit('input', { formData, selectedFiles })
      },
      bytesToMB (bytes) {
        if (bytes === 0) return 'n/a'

        return (bytes / (1024 ** 2)).toFixed(1)
      },    
    },
  }
</script> 
